import React from 'react'
import {MBSelect, MBSelectProps} from '../../../Common/Components/MBSelect'
import styled from '@emotion/styled'
import {Color} from '../Styles'
import selectorArrowIcon from '../../../img/bg-select.png'

const borderColor = ({hasError}: MBMemberSelectProps): string =>
  hasError ? Color.ErrorInputBorderColor : Color.Grey100
const focusBorderColor = ({hasError}: MBMemberSelectProps): string =>
  hasError ? Color.ErrorInputBorderColor : Color.Grey750
const backgroundColor = ({hasError}: MBMemberSelectProps): string =>
  hasError ? Color.ErrorInputBackgroundColor : Color.Grey40
const fontSize = ({fontSize}: MBMemberSelectProps): string => fontSize ? `${fontSize}` : '1.6'
const width = ({width}: MBMemberSelectProps): string => width ?? '100%'

const StyledSelect = styled(MBSelect)`
  font-size: ${fontSize}rem;
  line-height: inherit;
  padding: 4px 10px;
  margin: 0 5px 0;
  color: ${Color.Grey800};
  border: solid 1px ${borderColor};
  border-radius: 3px;
  background: url(${selectorArrowIcon}) right 5px top 15px  no-repeat;
  background-color: ${backgroundColor};
  background-size: 10px 6px;
  width: ${width};

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &:focus {
    border-color: ${focusBorderColor};
    outline: none;
  }

  &:first-of-type {
    margin-left: 0;
  }

  @media screen and (min-width: 769px) {
    font-size: 1.3rem;
  }
`

type MBMemberSelectProps = MBSelectProps & {
  fontSize?: number
  width?: string
}
export const MBMemberSelect: React.VFC<MBMemberSelectProps> = (props) => {
  return <StyledSelect {...props}>{props.children}</StyledSelect>
}
